export default "__VITE_ASSET__DFktyg0h__"